'use strict';

/* global $ */

let settings = {
    selector: '.js-folding-reviews',
    itemSelector: '.js-folding-reviews__item',
    contentSelector: '.js-folding-reviews__content'
};

class FoldingReviews {
    constructor(options) {
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ FoldingReviews/init ]');

        let $block = $(this.opt.selector);
        if ($block.length) {
            let $items = $block.find(this.opt.itemSelector);

            let maxLines = 5,
                time = 1000;
                
            for (let i = 0; i < $items.length; i ++) {
                let $item = $items.eq(i),
                    $content = $item.find(this.opt.contentSelector);

                let lineHeight = parseFloat($content.css('line-height')),
                    contentHeight = $content.height();

                if (contentHeight > maxLines * lineHeight) {
                    $content.addClass('is-folded').height(maxLines * lineHeight);

                    let $foot = $('<div />', { 'class': 'reviews__item-link' }).insertAfter($content),
                        $more = $('<a />', { 'class': 'show-more__link m--review', href: '#', text: 'Читать полностью' }).appendTo($foot);

                    $more.on('click', function(e) {
                        e.preventDefault();

                        let $this = $(this);
                        if ($content.hasClass('is-folded')) {
                            let contentHeight = $content.height(),
                                autoHeight = $content.css('height', 'auto').height();
                            $content.height(contentHeight);
                            $content.stop().animate({ height: autoHeight }, time);
                            $content.removeClass('is-folded');
                            $this.text('Свернуть');
                            $(window).trigger('resize');
                        } else {
                            $content.addClass('is-folded');
                            $content.animate({ height: maxLines * lineHeight }, time);
                            $this.text('Читать полностью');
                            $(window).trigger('resize');
                        }
                    });
                }
            }
            $(window).trigger('resize');
        }
    }
}


export {
    FoldingReviews
};